
import { computed, defineComponent, PropType } from '@vue/runtime-core'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Tag from '@/components/elements/Tag.vue'
import Button from '@/components/elements/Button.vue'
import { EventItem } from '@/types/Event'
import { formatDateToTime } from '@/utils/commonMethods'
export default defineComponent({
  name: 'EventCardHospital',

  components: {
    HeadingLv3,
    Button,
    Tag
  },

  props: {
    event: {
      type: Object as PropType<EventItem>
    }
  },

  setup(props) {
    console.log(props.event)
    const isOnline = computed(() =>
      props.event?.eventTypes?.includes('オンライン')
    )
    const isOffline = computed(() =>
      props.event?.eventTypes?.includes('オフライン')
    )
    const isCareer = computed(() =>
      props.event?.eventTypes?.includes('キャリアガイダンス')
    )

    const categoryIcon = computed(() => {
      if (isCareer.value) return require('@/assets/images/icon/book-white.svg')
      if (isOnline.value) return require('@/assets/images/icon/pc-white.svg')
      if (isOffline.value)
        return require('@/assets/images/icon/hospital-02-white.svg')
    })
    const eventTypeClass = computed(() => {
      if (isCareer.value) return 'isCareer'
      if (isOnline.value) return 'isOnline'
      if (isOffline.value) return 'isOffline'
    })
    const getEventLabelClass = (eventType: string): string | undefined => {
      if (eventType === 'キャリアガイダンス') return 'isCareer'
      if (eventType === 'オンライン') return 'isOnline'
      if (eventType === 'オフライン') return 'isOffline'
    }

    const latestSeminar = computed(() => {
      if (props.event?.seminar.length === 0) return []
      if (!props.event?.seminar) return []
      const lastItemIndex = props.event?.seminar?.length - 1
      return [props.event?.seminar[lastItemIndex]]
    })
    return {
      categoryIcon,
      eventTypeClass,
      getEventLabelClass,
      latestSeminar,
      formatDateToTime
    }
  }
})
